import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { withRouter, Link } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import { DataTable } from 'primereact/datatable';
import moment from 'moment-timezone';
import Paginator from '../../components/Paginator';
import SurveyProjectListHeader from './SurveyProjectListHeader';
import { toSortOrder, parse, sortUrl } from '../../utils/UrlUtil';

const messages = defineMessages({
  title: { id: 'attrs.title', defaultMessage: 'Title' },
  template: { id: 'attrs.template', defaultMessage: 'Template' },
  createdBy: { id: 'attrs.created_by', defaultMessage: 'Create by' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  numberOfSurveys: { id: 'surveyProject.numberOfSurveys', defaultMessage: 'Surveys' },
});

const nameTemplate = (rowData, { currentAccount, keyField, displayField }) => {
  const detailUrl = `/accounts/${currentAccount}/survey-projects/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const updated = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
};

const titleTemplate = rowData => (
  <p>{rowData.surveyTemplate.title}</p>
);

class SurveyProjectList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      location,
    } = this.props;
    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
      template: node.surveyTemplate.title,
      createdBy: node.createdBy ? `${node.createdBy.firstName} ${node.createdBy.lastName}` : '',
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;
    // header
    const nameHeader = formatMessage(messages.title);
    const templateHeader = formatMessage(messages.template);
    const createdByheader = formatMessage(messages.createdBy);
    const updatedHeader = formatMessage(messages.updated);
    const createdHeader = formatMessage(messages.created);
    const numberOfSurveysHeader = formatMessage(messages.numberOfSurveys);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel>
              <div className="p-grid">
                <div className="p-col-12">
                  <SurveyProjectListHeader currentAccount={currentAccount} />
                </div>
                <div className="p-col-12 align-center">
                  <DataTable
                    value={listRows}
                    responsive
                    sortField={sortBy}
                    sortOrder={toSortOrder(sortDir)}
                    onSort={this.onSortChange}
                    lazy
                    loading={loading}
                    autoLayout
                  >
                    <Column
                      field="name"
                      header={nameHeader}
                      body={nameTemplate}
                      keyField="id"
                      displayField="name"
                      currentAccount={currentAccount}
                      sortable
                      style={{ textAlign: 'left' }}
                    />
                    <Column
                      field="title"
                      header={templateHeader}
                      body={titleTemplate}
                      sortable
                    />
                    <Column
                      field="createdBy"
                      header={createdByheader}
                    />
                    <Column
                      field="updatedOn"
                      header={updatedHeader}
                      body={timeFieldTemplate}
                      sortable
                      formatDate={formatDate}
                    />
                    <Column
                      field="createdOn"
                      header={createdHeader}
                      body={timeFieldTemplate}
                      formatDate={formatDate}
                      sortable
                    />
                    <Column
                      field="numberOfSurveys"
                      header={numberOfSurveysHeader}
                    />
                  </DataTable>
                </div>
                <div className="p-col-12 align-center">{footer}</div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

SurveyProjectList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(injectIntl(SurveyProjectList));
